import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LogoutConfirmDialog } from '@/components/learner/LogoutConfirmDialog'
import { ProfileCard } from '@/components/learner/profile/ProfileCard'
import { AttendanceHistoryCard } from '@/components/learner/profile/AttendanceHistoryCard'
import { LearnerStatusBanner } from '@/components/learner/profile/LearnerStatusBanner'
import { PasswordChangeDialog } from '@/components/learner/profile/password/PasswordChangeDialog'
import { useLogout } from '@/hooks/useLogout'

export default function MyProfile() {
  const { t } = useTranslation('learner')
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false)
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false)
  const logout = useLogout()

  return (
    <section
      aria-labelledby="profile-page-heading"
      className="mx-auto flex w-full max-w-[1040px] flex-col gap-10 px-4 pb-10 pt-6 animate-lc-rise md:px-10 md:pt-10"
    >
      <header>
        <h1
          id="profile-page-heading"
          className="text-lc-v3-h3 font-bold text-lc-v3-gray-950"
        >
          {t('profile.title')}
        </h1>
      </header>
      <div className="flex flex-col gap-6">
        <LearnerStatusBanner />
        <ProfileCard
          onPasswordChange={() => setPasswordDialogOpen(true)}
          onLogout={() => setLogoutDialogOpen(true)}
        />
        <AttendanceHistoryCard />
      </div>

      <PasswordChangeDialog
        open={passwordDialogOpen}
        onClose={() => setPasswordDialogOpen(false)}
      />
      <LogoutConfirmDialog
        open={logoutDialogOpen}
        onCancel={() => setLogoutDialogOpen(false)}
        onConfirm={() => logout.mutate()}
        pending={logout.isPending}
      />
    </section>
  )
}
